/* eslint-disable @typescript-eslint/no-explicit-any */
import { useFormContext, useWatch } from 'react-hook-form';
import EpWizard from '../../../components/EpWizard';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { useTranslationStore } from '../../../stores/useTranslationStore';

export default function FormStepHeader({
  isClinicalPharmacy = false,
}: {
  isClinicalPharmacy?: boolean;
}) {
  const { translations, loading: loadingTranslations } = useTranslationStore(
    (state) => state,
  );
  const { setValue } = useFormContext();
  const activeStep = useWatch({ name: 'formUtils.activeStep' });

  const updateFormUtilsActiveStep = (step: any) => {
    setValue('formUtils.activeStep', step + 1);
  };

  const stepsIncident = [
    {
      title: t(translations['global'], 'Identification') as string,
      // isInitiallyActive: true,
      activeCallbackFunc: updateFormUtilsActiveStep,
      isInitiallyActive: activeStep === 1,
    },
    {
      title: t(
        translations['global'],
        'When and where did it take place?',
      ) as string,
      activeCallbackFunc: updateFormUtilsActiveStep,
      isInitiallyActive: activeStep === 2,
    },
    {
      title: t(translations['global'], 'How did this incident occur') as string,
      activeCallbackFunc: updateFormUtilsActiveStep,
      isInitiallyActive: activeStep === 3,
    },
    {
      title: t(translations['global'], 'Detection Mechanism') as string,
      activeCallbackFunc: updateFormUtilsActiveStep,
      isInitiallyActive: activeStep === 4,
    },
  ];

  const stepsPharmacy = [
    {
      title: t(translations['global'], 'Identification') as string,
      // isInitiallyActive: true,
      activeCallbackFunc: updateFormUtilsActiveStep,
      isInitiallyActive: activeStep === 1,
    },
    {
      title: t(
        translations['global'],
        'When and where did it take place?',
      ) as string,
      activeCallbackFunc: updateFormUtilsActiveStep,
      isInitiallyActive: activeStep === 2,
    },
    {
      title: t(
        translations['global'],
        'Clinical Pharmacy Categorization',
      ) as string,
      activeCallbackFunc: updateFormUtilsActiveStep,
      isInitiallyActive: activeStep === 3,
    },
    {
      title: t(translations['global'], 'Detection Mechanism') as string,
      activeCallbackFunc: updateFormUtilsActiveStep,
      isInitiallyActive: activeStep === 4,
    },
  ];

  if (loadingTranslations) {
    return null;
  }

  return (
    <EpWizard
      wizardId="steps-form-wizard"
      wizardSteps={isClinicalPharmacy ? stepsPharmacy : stepsIncident}
    />
  );
}
